import { Option } from "@intentsify/types";

export const isOption = (value: any): value is Option => {
  if (value?.value && value?.label) {
    return true;
  }

  return false;
};
